import { isEnglish } from './languages.js';

/**
 * Read a user's translation settings off whatever user model the host app
 * hands us.
 *
 * @param {object|null} [user]
 * @returns {{ language: string, active: boolean }}
 */
export function readTranslationSettings(user) {
    const source = user?.systemData ?? user ?? {};
    const language = source.translationLanguage || 'en';

    return {
        language,
        active: source.translationActive ?? !isEnglish(language),
    };
}
